import $ from 'jquery';

const theme = window.powersearchUserSettings.theme;
function setMapHtml(settings){
    $(settings.mapId).html(`<div class="hearby-mw-theme-light">
    <div class="hearbySearchForm"></div>
  <section class="a4map-wrap hearby-map-1">
  </section>
  <div class="event_popup-1 hearby-event-detail-overlay"  style="display:none">
  </div>`);
}
function setCarouselHtml(settings){
    $(settings.carouselId).html(`<div class="hearby-carousel-1 hearby-carousel-widget hearby-cw-theme-${theme}">
    <div class="hearby-carousel-header">
      <div class="hearby-carousel-info">
        <h3>Live shows <span class="hearby-event-count"></span></h3>
        
      </div>
    </div>
      <ul class="Slider1 hearby-content-slider">
      </ul>
  </div>`);
}
export {setCarouselHtml, setMapHtml}
    